import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import Darkbutton from "../components/Darkbutton";

import { AuthContext } from "../context/authContext";
import { RWebShare } from "react-web-share";

import "./customStyles.scss";
import { Conditional } from "@cloudinary/url-gen/actions/conditional";
class Header extends Component {
  state = {
    isOpen: false,
    isActive: false,
    isNoti: true,
    searchKey:"",
  };
  static contextType = AuthContext;

  toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });
  toggleActive = () => this.setState({ isActive: !this.state.isActive });
  //toggleisNoti = () => this.setState({ isNoti: !this.state.isNoti });


  render() {
    const { isLoggedIn, currentUser, logout } = this.context;
    const navClass = `${this.state.isOpen ? " nav-active" : ""}`;
    const buttonClass = `${this.state.isOpen ? " active" : ""}`;
    const searchClass = `${this.state.isActive ? " show" : ""}`;
    //const notiClass = `${this.state.isNoti ? " show" : ""}`;
    //const img = `${loggedInUserPic ? loggedInUserPic : "assets/images/gs.png"}`;
    const loginOption = `${isLoggedIn ? "Sign Out" : "Sign in"}`;
    //const loginLink = `${loggedInUser ? "logout" : "login"}`;

    const offNotification= () => {
      //console.log(this.state.isNoti);
     this.setState({isNoti:false});
    }

    const handleSubmit = e => {
      localStorage.setItem("searchkey",e.target.value);
    //console.log(e.target.value);
    }

    if(currentUser?.SID==='Banned') {
      logout();
    }

    const logoutFunction = () => {
      logout();
    };

    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: '#fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        height: '56px',
        display: 'flex',
        justifyContent: 'center'
      }}>
        {/* Aligns to the content panel below it, not to its own box.
            Widths/insets live in customStyles.scss next to the rules that set
            the content column, so the two cannot drift apart. */}
        <div className="gs-header__inner">
        {/* Logo */}
        <Link to="/">
          <img style={{ width: '50px', height: 'auto' }} src="https://files.geetsuhane.com/logo/gs_cupid_112.gif" alt="logo" />
        </Link>

        {/* Right icons - simplified for mobile */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Link to="/chatlist" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px' }}>
            <i className="feather-message-circle" style={{ fontSize: '16px', color: '#555' }}></i>
          </Link>
          <Link to="/notification" onClick={offNotification} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px' }}>
            <i className="feather-bell" style={{ fontSize: '16px', color: '#555' }}></i>
          </Link>
          <span onClick={this.toggleActive} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px', cursor: 'pointer' }}>
            <i className="feather-search" style={{ fontSize: '16px', color: '#555' }}></i>
          </span>
          <Link to="/login" onClick={isLoggedIn ? logoutFunction : null} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', background: isLoggedIn ? '#fee' : '#efe', borderRadius: '50%' }}>
            <i className={isLoggedIn ? "feather-log-out" : "feather-log-in"} style={{ fontSize: '18px', color: isLoggedIn ? '#c00' : '#090' }}></i>
          </Link>
          {isLoggedIn && currentUser?.picture ? (
            <Link to="/userpage" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px' }}>
              <img style={{ width: '28px', height: '28px', borderRadius: '50%', objectFit: 'cover' }} src={currentUser.picture && !currentUser.picture.includes('sgleusercontent.com') ? "https://files.geetsuhane.com/users/" + currentUser.picture : "/assets/user.png"} alt={currentUser?.name} />
            </Link>
          ) : null}
          {/* Hamburger menu button */}
          <button onClick={this.toggleOpen} style={{
            background: 'none',
            border: 'none',
            padding: '6px',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            width: '36px',
            height: '36px',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <span style={{ width: '18px', height: '2px', background: '#333', display: 'block' }}></span>
            <span style={{ width: '18px', height: '2px', background: '#333', display: 'block' }}></span>
            <span style={{ width: '18px', height: '2px', background: '#333', display: 'block' }}></span>
          </button>
        </div>

        {/* Dropdown Menu - shows when hamburger clicked */}
        {this.state.isOpen && (
          <>
          {/* Backdrop */}
          <div
            onClick={this.toggleOpen}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1001
            }}
          />
          {/* Menu */}
          <div style={{
            position: 'fixed',
            top: '60px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            zIndex: 1002,
            width: '90%',
            maxWidth: '320px',
            padding: '12px'
          }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '4px' }}>
              <Link onClick={this.toggleOpen} to="/" style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', textDecoration: 'none', color: '#333', borderRadius: '8px', background: '#f8f8f8' }}>
                <i className="feather-home" style={{ fontSize: '16px', marginRight: '10px', color: '#ff416c' }}></i>
                <span style={{ fontSize: '13px' }}>Home</span>
              </Link>
              <Link onClick={this.toggleOpen} to="/buzz" style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', textDecoration: 'none', color: '#333', borderRadius: '8px', background: '#f8f8f8' }}>
                <i className="feather-tv" style={{ fontSize: '16px', marginRight: '10px', color: '#4b7bec' }}></i>
                <span style={{ fontSize: '13px' }}>Buzz</span>
              </Link>
              <Link onClick={this.toggleOpen} to="/chess" style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', textDecoration: 'none', color: '#333', borderRadius: '8px', background: '#f8f8f8' }}>
                <i className="feather-grid" style={{ fontSize: '16px', marginRight: '10px', color: '#f7b731' }}></i>
                <span style={{ fontSize: '13px' }}>Chess</span>
              </Link>
              <Link onClick={this.toggleOpen} to="/dw" style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', textDecoration: 'none', color: '#333', borderRadius: '8px', background: '#f8f8f8' }}>
                <i className="feather-globe" style={{ fontSize: '16px', marginRight: '10px', color: '#26de81' }}></i>
                <span style={{ fontSize: '13px' }}>DreamWorld</span>
              </Link>
              <Link onClick={this.toggleOpen} to="/events" style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', textDecoration: 'none', color: '#333', borderRadius: '8px', background: '#f8f8f8' }}>
                <i className="feather-calendar" style={{ fontSize: '16px', marginRight: '10px', color: '#a55eea' }}></i>
                <span style={{ fontSize: '13px' }}>Events</span>
              </Link>
              <Link onClick={this.toggleOpen} to="/game" style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', textDecoration: 'none', color: '#333', borderRadius: '8px', background: '#f8f8f8' }}>
                <i className="feather-play-circle" style={{ fontSize: '16px', marginRight: '10px', color: '#eb3b5a' }}></i>
                <span style={{ fontSize: '13px' }}>Games</span>
              </Link>
              <Link onClick={this.toggleOpen} to="/planets" style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', textDecoration: 'none', color: '#333', borderRadius: '8px', background: '#f8f8f8' }}>
                <i className="feather-compass" style={{ fontSize: '16px', marginRight: '10px', color: '#20bf6b' }}></i>
                <span style={{ fontSize: '13px' }}>Planets</span>
              </Link>
              <Link onClick={this.toggleOpen} to="/search?members=50" style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', textDecoration: 'none', color: '#333', borderRadius: '8px', background: '#f8f8f8' }}>
                <i className="feather-users" style={{ fontSize: '16px', marginRight: '10px', color: '#3867d6' }}></i>
                <span style={{ fontSize: '13px' }}>Members</span>
              </Link>
              <Link onClick={this.toggleOpen} to="/userpage" style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', textDecoration: 'none', color: '#333', borderRadius: '8px', background: '#f8f8f8' }}>
                <i className="feather-user" style={{ fontSize: '16px', marginRight: '10px', color: '#8854d0' }}></i>
                <span style={{ fontSize: '13px' }}>Profile</span>
              </Link>
              <Link onClick={this.toggleOpen} to="/gupshup/main" style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', textDecoration: 'none', color: '#333', borderRadius: '8px', background: '#f8f8f8' }}>
                <i className="feather-message-circle" style={{ fontSize: '16px', marginRight: '10px', color: '#fa8231' }}></i>
                <span style={{ fontSize: '13px' }}>Gupshup</span>
              </Link>
            </div>
          </div>
          </>
        )}

        {/* Search overlay */}
        {this.state.isActive && (
          <>
          {/* Backdrop */}
          <div
            onClick={this.toggleActive}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1001
            }}
          />
          {/* Search box */}
          <div style={{
            position: 'fixed',
            top: '60px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '90%',
            maxWidth: '320px',
            zIndex: 1002,
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            padding: '12px'
          }}>
            <form action="/search" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input
                type="text"
                onChange={handleSubmit}
                placeholder="Search..."
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  border: '1px solid #eee',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none'
                }}
              />
              <button type="submit" style={{ padding: '10px 16px', background: '#ff416c', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
                Search
              </button>
              <span onClick={this.toggleActive} style={{ cursor: 'pointer', padding: '8px' }}>
                <i className="feather-x" style={{ fontSize: '18px', color: '#555' }}></i>
              </span>
            </form>
          </div>
          </>
        )}

        </div>
      </div>
    );
  }
}

export default Header;
